export default __webpack_public_path__ + "static/media/chloe_rooftop.d0c89585.jpg";